import { Box, Stack, Typography } from "@mui/material";

const ParentTeacher = () => {
  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
        spacing={2}
      >
        <Typography fontSize={16}>
          Modern College of Physiotherapy places great importance on effective
          communication between parents and teachers. To foster a strong
          partnership, regular Parent-Teacher Meetings (PTMs) are scheduled.
          These meetings provide a platform for parents to gain insights into
          their child's academic progress, behaviour, and overall development.
          PTMs are meticulously planned and scheduled to ensure maximum
          convenience for parents. Advance notifications, along with flexible
          timing options, are provided to accommodate diverse parental
          schedules. During these meetings, teachers discuss students' academic
          performance, strengths, areas for improvement, and attendance records.
          Parents are encouraged to share their child's strengths, challenges,
          or any concerns they may have. Additionally, PTMs offer an opportunity
          to explore strategies for enhancing student performance and address
          any behavioural issues collaboratively. By maintaining open and
          regular communication, the college aims to create a supportive
          environment for students to thrive academically and personally.
        </Typography>
      </Stack>
    </Box>
  );
};

export default ParentTeacher;
